<template>
  <b-modal
    id="case-draft-modal-list"
    hide-footer
    :header-bg-variant="headerVariant"
    header-text-variant="light"
    scrollable
    size="md"
  >
    <template v-slot:modal-title>
      <span>{{$t('label.draftcases.popupcontent.header')}}</span>
    </template>
    <template v-if="hasDraftCases">
      <DraftCaseRow 
        v-for="(aCase, index) in draftCases" 
        :key="index" 
        :draftCase="aCase" 
        :index="index"
        @reload-drafts="getDraftCases()"/>
    </template>
    <template v-else>
      <!-- No Drafts -->
      <b-row class="text-center" no-gutters>
        <b-col>
          <img class="placeholder" src="@/assets/placeholder.png"/><br/>
          <span class="my-4">No draft available.</span>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
//---- components ---------
import DraftCaseRow from "./DraftCaseRow.vue"
//---- mixins -------------
//---- services -----------
//---- 3rd-parties --------
import { mapGetters } from "vuex";

export default {
  components: {
    DraftCaseRow
  },

  created() {
    if (this.loggedIn && this.isProjectOpen) {
      this.getDraftCases();
    }
  }, // end created

  computed: {
    ...mapGetters({
      isProjectOpen: "projectData/isProjectOpen",
      loggedIn: "auth/loggedIn",
      draftCases: "draft/draftCases",
      hasDraftCases: "draft/hasDraftCases"
    })
  }, // end computed

  methods: {
    // get the draft list
    getDraftCases() {
      this.$store.dispatch("draft/getDraftCases");
    },
  } // end methods
};
</script>

<style scoped>
  .test + .test {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid lightgray;
  }
</style>
